import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import "./ChromeWarningBanner.css";

const ChromeWarningBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Check if user is using Chrome
    const isUsingGoogleChrome = () => {
      const ua = navigator.userAgent;
      const vendor = navigator.vendor || "";
      const isChromeDesktop = ua.includes("Chrome") && vendor === "Google Inc.";
      const isNotEdge = !ua.includes("Edg/");
      const isNotOpera = !ua.includes("OPR/");
      const isNotBrave = !ua.includes("Brave");
      return isChromeDesktop && isNotEdge && isNotOpera && isNotBrave;
    };

    // Banner disabled for now - will be enabled in future
    // Show on both mobile and desktop if not using Chrome
    // Temporarily force show for testing - remove this line after testing
    // setShowBanner(true);
    
    // Uncomment below for production
    // if (!isUsingGoogleChrome()) {
    //   setShowBanner(true);
    // } else {
    //   setShowBanner(false);
    // }
  }, [isDesktop]);

  if (!showBanner) return null;

  return (
    <div className="chrome-warning-banner">
      <div className="chrome-warning-banner__content">
        <div className="chrome-warning-banner__icon-wrapper">
          <Icon icon="logos:chrome" width="18" height="18" />
        </div>
        <div className="chrome-warning-banner__text">
          <span>Sponsor App is currently supported only in Google Chrome.</span>
        </div>
      </div>
      <button
        className="chrome-warning-banner__close"
        onClick={() => setShowBanner(false)}
        aria-label="Close"
      >
        <Icon icon="mdi:close" width="18" height="18" style={{ color: '#FFFFFF' }} />
      </button>
    </div>
  );
};

export default ChromeWarningBanner;
